import {useEditor, useNode} from '@craftjs/core';
import { Button as AntdButton, Modal, App } from "antd";
import React,{Fragment, useContext, useState, useRef} from 'react';
import styled from 'styled-components';
import { Settings } from './settings';
import { FormContext } from 'wsc-react-custom-form';
import axios from 'axios';

const StyledDiv = styled.div`
  background: ${(props) => `rgba(${Object.values(props.background)})`};
  border: 2px solid transparent;
  margin: ${({ margin }) =>
    `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`};
`;


export const AddOrEditButton = ({ size, ghost, variant, color, api,
                                text,
                                name,
                                placeholder,
                                type,
                                headers,
                                idForEdit,
                                editApi,
                                disabled, ...props }) => {
    const { modal } = App.useApp();
    const { form,OnPayload,axiosConfig,onBeforeSubmit } = useContext(FormContext);
    const [loading,setLoading] = useState(false);
    const {editorEnabled} = useEditor(state => ({
        editorEnabled: state.options.enabled,
    }));
    const clicked = useRef(false);

    const handleClick = (e) => {
        e.preventDefault();
        if (editorEnabled) return;
        if (clicked.current) {
            console.log('click slower!');
            return;
        }
        clicked.current = true;

        form.validateFields()
            .then(async (values) => {
                try {
                    setLoading(true);
                    if (typeof onBeforeSubmit === 'function') {
                        values = onBeforeSubmit(values);
                    }

                    // 转换为修改api
                    let postApi = api;
                    // 配置了id字段 + 配置了edit api，并且数据中存在Id字段，且Id字段值非空
                    if (idForEdit && editApi && Object.hasOwn(values, idForEdit) && !!values[idForEdit]) {
                        postApi = editApi;
                    }

                    let targetUrl = ((postApi != null && postApi.indexOf("http")) > -1 ? postApi:((axiosConfig.baseURL?axiosConfig.baseURL:"") + postApi));
                    let result = await axios(targetUrl, { method: "POST", data: values, headers: {...axiosConfig.headers,...headers} })
                    if (result.status === 200) {
                        //http请求成功
                        const fnResult = OnPayload(form, name, { formvalue: values, apiresult: result.data });
                        Promise.resolve(fnResult).finally(()=>clicked.current = false);
                    } else {
                        modal.error({ content: <Fragment><div>网络请求错误，错误代码：{result.status}</div><div>{result.statusText}</div></Fragment> });
                        clicked.current = false
                    }
                    setLoading(false);
                } catch (error) {
                    modal.error({ content: <Fragment><div>网络请求错误，错误代码：{error.status}</div><div>{error.message}</div></Fragment> });
                    setLoading(false);
                    clicked.current = false
                }
            })
            .catch((values)=>{
                console.log('invalidate: ', values);
                clicked.current = false;
            })
        ;
    }

    const {
        connectors: { connect },
    } = useNode((node) => ({
        selected: node.events.selected,
    }));
    const isTrueSet = ghost === 'true';
    return (<StyledDiv ref={connect} {...props} >
        <AntdButton loading={loading} size={size} type={type} onClick={handleClick} ghost={isTrueSet}>{text}</AntdButton>
    </StyledDiv>);
};


AddOrEditButton.craft = {
    displayName: 'AddOrEditButton',
    props: {
        background: { r: 255, g: 255, b: 255, a: 0.5 },
        color: { r: 92, g: 90, b: 90, a: 1 },
        size: "default",
        type: "default",
        ghost: "false",
        text: 'AsyncButton',
        name: "ok",
        margin: ['5', '0', '5', '0'],
        headers: {},
        idForEdit: '',
        editApi: '',
    },
    related: {
        toolbar: Settings,
    },
};